import useAxios from '../../../../app/hooks/useAxios';
import { useQuery } from '@tanstack/react-query';

interface IAuthOktaUserFactorQuestion {
	question: string;
	questionText: string;
}

const useAuthOktaUserFactorQuestions = () => {
	const { get } = useAxios();

	return useQuery(['authOktaUserFactorQuestions'], async () => {
		const response = await get(`/users/me/factors/questions`);
		return response.data as IAuthOktaUserFactorQuestion[];
	});
};

export default useAuthOktaUserFactorQuestions;
